import { InjectionToken } from '@angular/core';
import { ClientType } from '@pcp/core/interfaces';

/**
 * Injection token for the client type. Provided per-app using the existing
 * `ClientType` from `@pcp/core/interfaces`.
 *
 * Write permissions: only Teacher and Beamer can write to Y.Doc.
 * All others (LiveLessonModerator, LiveLessonStudent, Student) are read-only.
 */
export const LESSON_YJS_CLIENT_TYPE = new InjectionToken<ClientType>(
    'LESSON_YJS_CLIENT_TYPE'
);
